import styled from '@emotion/styled'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('div')`
  color: ${themeVars.ultraLight};
  line-height: 24px;
`
